import React from 'react';
import logo from '../../styles/img/PI_Brain_White.png';
import halloween from '../../styles/img/jack-o-lantern.png';

export class DisplayIcon extends React.Component {
  render() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const halloweenFrom = Date.parse('10/24/' + year);
    const halloweenTo = Date.parse('11/07/' + year);

    if (currentDate >= halloweenFrom && currentDate <= halloweenTo) {
      return <img src={ halloween } alt="PI Logo" width={ 40 } height={ 40 } />;
    } else {
      return <img src={ logo } alt="PI Logo" width={ 61 } height={ 50 } />;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/navigation/display_icon.jsx